import loadable from '@loadable/component';

const LoadableMobileSiteNavMenu = loadable(() => import('./mobileSiteNavMenu'));

export default LoadableMobileSiteNavMenu;
